module.exports = __webpack_public_path__ + "static/media/bg_feature_3.745e662f.jpg";